// scroll-arrows.js
document.addEventListener('DOMContentLoaded', function() {
  const leftArrows = document.querySelectorAll('.scroll-arrow.left');
  const rightArrows = document.querySelectorAll('.scroll-arrow.right');
  const scrollableContents = document.querySelectorAll('.scrollable-content');

  leftArrows.forEach((arrow, index) => {
    arrow.addEventListener('click', function() {
      scrollableContents[index].scrollBy({ left: -300, behavior: 'smooth' });
    });
  });

  rightArrows.forEach((arrow, index) => {
    arrow.addEventListener('click', function() {
      scrollableContents[index].scrollBy({ left: 300, behavior: 'smooth' });
    });
  });
});
